import SectionHeader from "../../components/commonUi/SectionHeader";
import Board from "@asseinfo/react-kanban";
import "@asseinfo/react-kanban/dist/styles.css";
import "./task.css";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useEffect, useState } from "react";
import BoardData from "../../components/commonUi/taskdata.json";
import CardItem from "../../components/commonUi/CardItem";
import { GoPlus } from "react-icons/go";
import { BsSearch } from "react-icons/bs";

function createGuidId() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
const Tasks = () => {
  const [ready, setReady] = useState(false);
  const [boardData, setBoardData] = useState(BoardData);
  const [showForm, setShowForm] = useState(false);
  const [selectedBoard, setSelectedBoard] = useState(0);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setReady(true);
    }
  }, []);

  const onDragEnd = (re) => {
    if (!re.destination) return;
    let newBoardData = boardData;
    var dragItem =
      newBoardData[parseInt(re.source.droppableId)].items[re.source.index];
    newBoardData[parseInt(re.source.droppableId)].items.splice(
      re.source.index,
      1
    );
    newBoardData[parseInt(re.destination.droppableId)].items.splice(
      re.destination.index,
      0,
      dragItem
    );
    setBoardData(newBoardData);
  };

  const onTextAreaKeyPress = (e) => {
    if (e.keyCode === 13) {
      //Enter
      const val = e.target.value;
      if (val.length === 0) {
        setShowForm(false);
      } else {
        const boardId = e.target.attributes["data-id"].value;
        const item = {
          id: createGuidId(),
          title: val,
          priority: 0,
          chat: 0,
          attachment: 0,
          assignees: [],
        };
        let newBoardData = boardData;
        newBoardData[boardId].items.push(item);
        setBoardData(newBoardData);
        setShowForm(false);
        e.target.value = "";
      }
    }
  };

  return (
    <div className="px-7">
      <div className="flex justify-between items-center">
        <SectionHeader
          title={"Task Management"}
          objective={"Monitor and Analyze key data metrices and KPIs."}
        />

        <div className="flex justify-center items-center gap-8 mt-4">
          <div className="relative">
            <BsSearch className="absolute top-2.5 left-3 text-gray-500" />
            <input
              type="name"
              id="search"
              placeholder="Search"
              name="search"
              className="pl-10 border border-gray-400 w-full rounded-[5px] h-9"
            />
          </div>
          <button className="hover:bg-[#161B22] bg-[#161b22d1] text-white font-normal py-2 px-4 rounded-md inline-flex items-center">
            <GoPlus className="font-bold text-xl" />
            <span>New Project</span>
          </button>
        </div>
      </div>
      <div className="mt-16">
        {ready && (
          <DragDropContext onDragEnd={onDragEnd}>
            <div className="grid grid-cols-4 gap-5 my-5">
              {boardData.map((board, bIndex) => {
                return (
                  <div key={board.name}>
                    <Droppable droppableId={bIndex.toString()}>
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}>
                          <div
                            className={`bg-gray-100 rounded-md shadow-md
                            flex flex-col relative overflow-hidden border
                            ${snapshot.isDraggingOver && "bg-green-100"}`}>
                            <span
                              className={`w-full h-1
                          absolute inset-x-0 top-0 ${
                            board?.name == "In Development"
                              ? "bg-blue-500"
                              : board?.name == "Delivered"
                              ? "bg-green-600"
                              : board?.name == "Approval Awiting"
                              ? " bg-indigo-500"
                              : "bg-gray-600"
                          }`}></span>
                            <h4 className=" p-3 flex justify-between items-center mb-2">
                              <span className="text-xl text-gray-600">
                                {board?.name}
                              </span>
                              {/* <DotsVerticalIcon className="w-5 h-5 text-gray-500" /> */}
                            </h4>
                            <div
                              className="overflow-y-auto overflow-x-hidden h-auto"
                              style={{ maxHeight: "calc(100vh - 290px)" }}>
                              {board.items.length > 0 &&
                                board.items.map((item, iIndex) => {
                                  return (
                                    <CardItem
                                      key={item.id}
                                      data={item}
                                      index={iIndex}
                                      className="m-3"
                                    />
                                  );
                                })}
                              {provided.placeholder}
                            </div>

                            {showForm && selectedBoard === bIndex ? (
                              <div className="p-3">
                                <textarea
                                  className="border-gray-300 rounded focus:ring-purple-400 w-full"
                                  rows={3}
                                  placeholder="Task info"
                                  data-id={bIndex}
                                  onKeyDown={(e) => onTextAreaKeyPress(e)}
                                />
                              </div>
                            ) : (
                              <button
                                className="flex justify-center items-center my-3 border border-gray-700 space-x-2 text-lg"
                                onClick={() => {
                                  setSelectedBoard(bIndex);
                                  setShowForm(true);
                                }}>
                                <span>Add task</span>
                                {/* <PlusCircleIcon className="w-5 h-5 text-gray-500" /> */}
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                    </Droppable>
                  </div>
                );
              })}
            </div>
          </DragDropContext>
        )}
      </div>
    </div>
  );
};

export default Tasks;
